import { Component, OnInit, OnDestroy } from '@angular/core';

import { Store } from '@src/store';
import { DialogManagerService } from '@src/services';
import { userActions } from '@src/store/reducers/userReducer';

import * as _ from 'lodash';

@Component({
    selector: 'roles-management',
    template: require('./roles-management.component.html'),
    styles: [require('./roles-management.component.scss')]
})
export class RolesManagementComponent implements OnInit, OnDestroy {
    public roles: any[];
    public role: any;

    private unSubscribe: any;
    private unSubscribers: any[];
    private indexInList: any;

    constructor(
        private store: Store,
        private dialogManagerService: DialogManagerService) {
    }

    public ngOnInit() {
        this.unSubscribe = this.store.subscribe(() => {
            const userState = this.store.getState().user;
            if (userState.roles) {
                this.roles = userState.roles;
                this.role = userState.role;
                this.unSubscribe();
            }
        });
        this.unSubscribers = [
            this.store.subscribe(() => {
                const userState = this.store.getState().user;
                if (userState.role) {
                    this.roles = userState.roles;
                    this.role = userState.role;
                    this.updateRolesListOnSave();
                }
            })
        ];
        this.store.dispatch({ type: userActions.GET_ROLES });
    }

    public ngOnDestroy() {
        this.unSubscribers.forEach(x => x());
    }

    private updateRolesListOnSave() {
        const selectedRole = this.roles.filter(role => role.id === this.role.id);
        if (selectedRole && selectedRole.length > 0) {
            selectedRole[0].name = this.role.name;
            selectedRole[0].description = this.role.description;
        }
        this.roles.sort((a, b) => {
            const nameA = a.name.toUpperCase();
            const nameB = b.name.toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            return nameA > nameB ? 1 : 0;
        });
    }

    public getRole(selectedRole: any, indexInList: any) {
        this.indexInList = indexInList;
        if (selectedRole.isNew) {
            this.role = selectedRole;
            return;
        }
        this.store.dispatch({
            type: userActions.GET_ROLE,
            payload: { roleId: selectedRole.id }
        });
    }

    public addRole() {
        this.role = { name: 'New Role', isNew: true };
        this.roles = [this.role, ...this.roles];
        this.indexInList = 0;
        this.getRole(this.role, 0);
    }

    public duplicateRole() {
        this.store.dispatch({
            type: userActions.DUPLICATE_ROLE,
            payload: { roleId: this.role.id }
        });
    }

    public deleteRole() {
        const onConfirm = () => {
            if (this.role.isNew) {
                if (this.indexInList >= 0) {
                    this.roles = [...this.roles.slice(0, this.indexInList), ...this.roles.slice(this.indexInList + 1)]
                    this.role = this.roles ? this.roles[0] : null;
                }
                return;
            }
            this.unSubscribe = this.store.subscribe(() => {
                const user = this.store.getState().user;
                if (user.roles) {
                    if (this.roles.length > user.roles.length) {
                        this.roles = user.roles;
                        this.unSubscribe();
                    }
                }
            });
            this.store.dispatch({ type: userActions.DELETE_ROLE, payload: { roleId: this.role.id } });
        };
        const dialogData = { title: 'Delete Role', action: 'delete', objectType: 'role', item: this.role.name };
        this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/roles-management/roles-management.component.ts